<kodit-page [showCardBlock]="showCardBlock">
  <kodit-table [tableConfig]="tableConfig" [items]="sastavnicaTable">
  </kodit-table>
</kodit-page>
